import React from "react";
import DialogContent from '@mui/material/DialogContent';
import {Dialog} from '@mui/material';
import {useLocales} from "../../locales";
import LoadingSegment from "../loadingSegment";

export default function ProcessingDialog({loading}) {
    const {translate} = useLocales();

    return (
        <Dialog open={loading} aria-labelledby="processing-dialog-title" disableEscapeKeyDown>
            <DialogContent>
                <LoadingSegment text={translate("ongoingProcess")}/>
            </DialogContent>
        </Dialog>
    );
}
